/* common imports */
import React from "react";

/* component imports */
import SectionOne from "./Privacy/SectionOne";
import SectionTwo from "./Privacy/SectionTwo";

/* @mui imports */

import { styled } from "@mui/system";
const Container = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
}));

/* stylings */

const Privacy = () => {
	return (
		<React.Fragment>
			<Container>
				<SectionOne />
				<SectionTwo />
			</Container>
		</React.Fragment>
	);
};
export default Privacy;
